
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<ExpansionPanel>({})
export default class ExpansionPanel extends Vue {
	@Prop({ type: Object, required: false, default: () => {} }) private panelProps!: object;
	@Prop({ type: Object, required: false, default: () => {} }) private headerProps!: object;
	@Prop({ type: Object, required: false, default: () => {} }) private contentProps!: object;
	@Prop({ type: Boolean, default: true }) private expanded!: boolean;
	@Prop({ type: Boolean, default: false }) private iconOnly!: boolean;

	$refs!: {
		header: Vue
	};

	public open: number = 1;

	private created(): void {
		this.open = this.expanded ? 0 : 1;
	}

	private mounted(): void {
		if (this.iconOnly) {
			const header = this.$refs.header?.$el;
			if (header) {
				header.addEventListener('click', this.onHeaderClick, true);
			}
		}
	}

	private beforeDestroy(): void {
		if (this.iconOnly) {
			const header = this.$refs.header?.$el;
			if (header) {
				header.removeEventListener('click', this.onHeaderClick, true);
			}
		}
	}

	/**
	 * When iconOnly is true, only toggle when clicking the expand icon
	 *
	 * @param {Event} event
	 * @return {void}
	 */
	private onHeaderClick(event: Event): void {
		const target = event.target as HTMLElement;
		if (!target.closest('.v-expansion-panel-header__icon')) {
			event.stopPropagation();
		}
	}
}

